import { render, staticRenderFns } from "./DownLive.vue?vue&type=template&id=f0c8084e&"
import script from "./DownLive.vue?vue&type=script&lang=js&"
export * from "./DownLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports